import { EventEmitter, Injectable, InjectionToken, Injector } from '@angular/core';
import { ComponentType } from '@angular/cdk/portal';
import { Subject } from 'rxjs';
import { INotificationItem } from '@fi-app/utilities/notification/notification';
import { removeItem } from '@fi-shared/utils/remove-item';

export const NotificationRef = new InjectionToken('NotificationRef');

@Injectable()
export class FiNotificationService {
    currentId = 0;
    notifications = [];
    notificationAdded = new EventEmitter();

    constructor(private injector: Injector) {}

    AddNotification(factory: ComponentType<any>, injector?: Injector) {
        const notiRef: INotificationItem = {
            id: ++this.currentId,
            factory: factory,
            HideNotification: () => {
                removeItem(this.notifications, notiRef);
            },
            countdownFinished: new Subject<void>(),
        };

        const notiInjector = Injector.create({
            providers: [
                {
                    provide: NotificationRef,
                    useValue: notiRef,
                },
            ],
            parent: injector || this.injector,
        });

        notiRef.injector = notiInjector;

        this.notifications.push(notiRef);
        this.notificationAdded.emit(notiRef);

        return notiRef;
    }
}
